import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import React from "react";
import Map, { MapRef } from "react-map-gl/maplibre";
import { useCallbackRef } from "../hooks/useCallbackRef";

export interface BaseMapProps extends React.ComponentPropsWithoutRef<typeof Map> {
  destination: google.maps.LatLngLiteral;
  children?: React.ReactNode;
}

const BaseMap = React.forwardRef((props: BaseMapProps, ref: React.Ref<MapRef>) => {
  const { onLoad, zoom, pitch, destination, minZoom, maxZoom, scrollZoom, ...rest } = props;
  const onLoadRef = useCallbackRef(onLoad);

  const onMapLoad = React.useCallback(
    (e: maplibregl.MapLibreEvent<unknown>) => {
      console.log("map loaded");
      onLoadRef(e);
    },
    [onLoadRef]
  );

  const initialViewState = React.useRef({
    zoom: zoom ?? 12,
    pitch: pitch ?? 0,
    latitude: destination.lat,
    longitude: destination.lng,
  });

  return (
    <Map
      {...rest}
      ref={ref}
      trackResize={false}
      initialViewState={initialViewState.current}
      minZoom={minZoom ?? 3}
      maxZoom={maxZoom ?? 22}
      scrollZoom={scrollZoom === false ? false : true}
      mapStyle="https://d3l0mkr2ggho68.cloudfront.net/mobile-assets/style-tiles-gray.json"
      onLoad={onMapLoad}
      attributionControl={false}
    />
  );
});

export default BaseMap;
